// JavaScript Function
export function itemFilter() {

    //And-logic
    /*
    function filterItems() {
        const checkboxes = document.querySelectorAll('.js-filter-checkbox');
        const items = document.querySelectorAll('.filter-item');

        const checkedValues = Array.from(checkboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);

        items.forEach(item => {
            const itemValues = item.getAttribute('data-category').split(' ');
            const showItem = checkedValues.every(value => itemValues.includes(value));
            if (showItem) {
                item.classList.add('show');
            } else {
                item.classList.remove('show');
            }
        });
    }
     */
    //Or-logic
    // JavaScript Function
    function filterItems() {
        const checkboxes = document.querySelectorAll('.js-filter-checkbox');
        const items = document.querySelectorAll('.filter-item');

        const checkedValues = Array.from(checkboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);
        checkboxes.forEach(function(checkbox) {
            if (checkbox.checked) {
                checkbox.closest('.filter').classList.add('active');
            } else {
                checkbox.closest('.filter').classList.remove('active');
            }
        });
        if (checkedValues.length) {
            items.forEach(item => {
                item.classList.remove('show');
                item.style.opacity = '0';
                const itemValues = item.getAttribute('data-category').split(' ');
                const showItem = checkedValues.some(value => itemValues.includes(value));

                setTimeout(function() {
                    if (showItem) {
                        item.classList.add('show');
                        setTimeout(function () {
                            item.style.opacity = '1';
                        }, 250);
                    } else {
                        item.classList.remove('show');
                        item.style.opacity = '0';
                    }
                    const activeItems = document.querySelectorAll('.filter-item.show');
                    activeItems.forEach((item, index) => {
                        // Calculate delay based on index
                        const delay = index * 100;

                        // Add the transition class with calculated delay
                        item.style.transitionDelay = delay + 'ms';
                    });
                }, 150);
            });
        } else {
            items.forEach(item => {
                item.style.opacity = '1';
                item.classList.add('show');
            });
        }
    }

    // Event Listener for checkbox changes
    document.querySelectorAll('.js-filter').forEach(checkbox => {
        checkbox.addEventListener('change', filterItems);
    });

    return 'itemFilter';
}